import { StopAPI } from '../../../api/bussched/StopAPI';

const ERR_MSG = "Ocorreu um erro a ler as Paragens da Linha selectionada";

export class StopsCommand {
    list(edition, successCallback, errorCallback) {
        const apiResult = StopAPI.list(edition);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback(ERR_MSG);
            }
        });
    }
}
